module.exports = __webpack_public_path__ + "static/00003.b4fc5394.jpg";